import {
  useSetMediaArchivedMutation,
  useSetMediaNonCurrentMutation,
  useSetMediaVerifiedMutation,
} from '../api'

export const useActionLoading = () => {
  const [, { isLoading: nonCurrentLoading }] = useSetMediaNonCurrentMutation({
    fixedCacheKey: 'set-non-current',
  })
  const [, { isLoading: verifyLoading }] = useSetMediaVerifiedMutation({
    fixedCacheKey: 'set-verified',
  })
  const [, { isLoading: archiveLoading }] = useSetMediaArchivedMutation({
    fixedCacheKey: 'set-archived',
  })

  return nonCurrentLoading || verifyLoading || archiveLoading
}
